import './ConfirmationModal.css';

const ConfirmationModal = ({
  open, title, children, confirmLabel, onConfirm, onCancel, submitting = false
}) => {
  if (!open) return null;
  return (
    <div className="confirmation-modal-backdrop" role="presentation">
      <div className="confirmation-modal" role="dialog" aria-modal="true" aria-labelledby="confirmation-modal-title">
        <h2 id="confirmation-modal-title">{title}</h2>
        {children}
        <div className="confirmation-modal-actions">
          <button type="button" onClick={onCancel} disabled={submitting}>Cancel</button>
          <button type="button" onClick={onConfirm} disabled={submitting}>
            {submitting ? 'Working…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
